import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CancelDeviceSignalDocument } from './cancel.generated';

export const useCancelDeviceSignal = (
  options: ApiOptions<typeof CancelDeviceSignalDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CancelDeviceSignalDocument, {
    ...useNotifications(CancelDeviceSignalDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.device_signals.cancel_success'),
    }),
    ...options,
  });
};
